<template>
  <b-row>
    <b-col>
      <form @submit.prevent="submit()">
        <b-row>
          <b-col v-if="getAgreementTagOptions.length > 0" cols="4">
            <b-form-group>
              <label>{{$t("views.agreements.form.tags")}}: </label>
              <multi-select :options="getAgreementTagOptions" :selected-options="data.agreementTags" @select="onSelectTags" >
              </multi-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label>{{$t("views.agreements.form.documentTemplate")}}: </label>
              <model-select
                @input="onSelectDocumentTemplate($event)"
                class="invalid-feedback"
                name="document_template"
                :options="getDocumentTemplateOptions"
                v-model="data.documentTemplate" required >
              </model-select>
              <div v-if="isInvalid('documentTemplate')" class="text-danger">
                {{ violations.documentTemplate }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label>{{$t("views.exsbsettlements.show.batchNumber")}}: </label>
              <model-select
                @input="$forceUpdate()"
                class="invalid-feedback"
                name="batch_number"
                :options="batchNumbers"
                v-model="data.batchNumber">
              </model-select>
              <div v-if="isInvalid('batchNumber')" class="text-danger">
                {{ violations.batchNumber }}
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="customSymbol">{{$t("views.application.form.subdomain")}}:</label>
              <input v-model="data.applicationName"
                     name="applicationName" type="text"
                     autofocus :placeholder="$t('views.application.form.subdomain')"
                     class="form-control" id="applicationName"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="customSymbol">{{$t("views.application.form.linkedApplicationNames")}}:</label>
              <input v-model="data.linkedApplicationNames"
                     name="linkedApplicationNames" type="text"
                     autofocus :placeholder="$t('views.application.form.linkedApplicationNames')"
                     class="form-control" id="linkedApplicationNames"/>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="mt-2 mb-2">
        <UserData
          :data="data"
          :violations="violations"
          :is-invalid="isInvalid">
        </UserData>
        <hr class="mt-2 mb-2">
        <DatesSettings
          :data="data"
          :violations="violations"
          :is-invalid="isInvalid">
        </DatesSettings>
        <AgreementItems
          :data="data"
          :violations="violations"
          :is-invalid="isInvalid">
        </AgreementItems>
        <AgreementAdditionalItems
          v-if="data.type === 1"
          :data="data"
          :violations="violations"
          :is-invalid="isInvalid">
        </AgreementAdditionalItems>
        <AgreementPromotions
          :data="data"
          :violations="violations">
        </AgreementPromotions>
        <AgreementInvoices
          :data="data"
          :violations="violations"
          :is-invalid="isInvalid">
        </AgreementInvoices>
        <AdvancePayment
          :data="data"
          :violations="violations">
        </AdvancePayment>
        <AgreementDevices
          :data="data"
          :violations="violations">
        </AgreementDevices>
        <AgreementCustomFields
          :data="data"
          :violations="violations"
          :is-invalid="isInvalid"
        ></AgreementCustomFields>
<!--        <AdditionalInfo></AdditionalInfo>-->
        <hr class="mt-1 mb-1">
        <b-row>
          <b-col cols="6">
            <AgreementConsents
              :data="data"
              :violations="violations">
            </AgreementConsents>
          </b-col>
        </b-row>
        <button type="button" class="btn btn-success" @click="submit()">{{$t('buttons.submit')}}</button>
      </form>
      <button type="button" class="btn btn-warning" @click="showPreview()">{{$t('buttons.agreementPreview')}}</button>
      <AgreementPreviewHTMLModal></AgreementPreviewHTMLModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { MultiSelect, ModelSelect } from 'vue-search-select'
import DatesSettings from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/DatesSettings'
import UserData from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/UserData'
import AgreementItems from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementItems'
import AdvancePayment from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AdvancePayment'
import AgreementConsents from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementConsents'
import AgreementPreviewHTMLModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/AgreementPreviewHTMLModal'
import AgreementPromotions from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementPromotions'
import AgreementDevices from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementDevices'
import AgreementInvoices from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementInvoices'
import AgreementCustomFields from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementCustomFields'
import remove from '@/utils/remove'
import AgreementAdditionalItems from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementAdditionalItems'

export default {
  name: 'Form',
  components: {
    AgreementAdditionalItems,
    AgreementCustomFields,
    AgreementDevices,
    AgreementPromotions,
    DatesSettings,
    UserData,
    AgreementItems,
    MultiSelect,
    // AdditionalInfo,
    ModelSelect,
    AdvancePayment,
    AgreementConsents,
    AgreementPreviewHTMLModal,
    AgreementInvoices
  },

  props: ['values', 'initialValues', 'handleSubmit', 'violations'],

  data () {
    return {
      item: {},
      lastSelectTag: {}
    }
  },
  computed: {
    ...mapGetters({
      getAgreementTagOptions: 'agreements/list/getAgreementTagOptions',
      getDocumentTemplateOptions: 'agreements/list/getDocumentTemplateOptions',
      batchNumberOptions: 'exsbinvoice/list/batchNumberOptions'
    }),
    batchNumbers () {
      let batchNumbers = this.batchNumberOptions.filter(entry => {
        return entry.agreementsAllowed === 1
      })
      batchNumbers.unshift({
        text: this.$t('global.notSet'),
        value: null
      })
      return batchNumbers
    },
    data () {
      return this.values || this.initialValues
    }
  },

  watch: {
    'data.agreementTags' (newVal, oldVal) {
      if (!this.item['@id']) {
        return
      }
      let deletedTags = oldVal.filter(tag => !newVal.includes(tag))
      deletedTags.forEach((deletedTag) => {
        if (deletedTag['@id']) {
          this.deleteTagHandler(deletedTag)
        }
      })
    }
  },

  created () {
    this.fetchAgreementTagOptions()
    this.fetchDocumentTemplateOptions()
    this.fetchBatchNumberOptions()
  },

  methods: {
    showPreview () {
      this.toggleAgreementPreviewHTMLModal()
      this.fetchAgreementPreview(this.data)
    },
    ...mapActions({
      fetchAgreementTagOptions: 'agreements/list/fetchAgreementTagOptions',
      fetchDocumentTemplateOptions: 'agreements/list/fetchDocumentTemplateOptions',
      fetchBatchNumberOptions: 'exsbinvoice/list/fetchBatchNumberOptions',
      fetchAgreementPreview: 'agreements/previewModal/fetchAgreementPreview'
    }),
    ...mapMutations({
      toggleAgreementPreviewHTMLModal: 'agreements/previewModal/toggleAgreementPreviewHTMLModal'
    }),
    onSelectTags (items, lastSelectItem) {
      this.data.agreementTags = items
      this.lastSelectTag = lastSelectItem
    },
    onSelectDocumentTemplate (val) {
      let documentTemplate = this.getDocumentTemplateOptions.find(entry => entry.value === val)
      if (documentTemplate) {
        this.data.batchNumber = documentTemplate.idDefaultBatchNumber
      }
      this.$forceUpdate()
    },
    deleteTagHandler (tag) {
      remove(tag['@id'])
    },
    submit () {
      if (this.data.paymentFrequency) this.data.paymentFrequency = parseInt(this.data.paymentFrequency)
      this.handleSubmit()
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
